import {
    get_manutenzioni,
    get_manutenzione,
    create_manutenzione,
    update_manutenzione,
    inizia_manutenzione,
    completa_manutenzione,
    modifica_ricambi_manutenzione,
    duplica_manutenzione,
    elimina_manutenzione,
} from "@/api/api.manutenzione.js";

const manutenzioni = {
    namespaced: true,

    state: {
        lista: [],
        corrente: null,
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
        SET_CORRENTE: (state, m) => {
            state.corrente = m;
        },
    },

    actions: {
        carica({ commit }, filtri) {
            return new Promise((resolve, reject) => {
                get_manutenzioni(filtri).then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaDettaglio({ commit }, id) {
            return new Promise((resolve, reject) => {
                get_manutenzione(id).then(resp => {
                    commit("SET_CORRENTE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        pianifica({ dispatch }, dati) {
            return new Promise((resolve, reject) => {
                create_manutenzione(dati).then(resp => {
                    dispatch("carica", { macchinaId: dati.macchinaId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        riprogramma({ dispatch }, { id, dati, macchinaId }) {
            return new Promise((resolve, reject) => {
                update_manutenzione(id, dati).then(resp => {
                    dispatch("carica", { macchinaId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        // Avvia il fermo macchina (Pianificata -> InCorso), solo se richiedeFermoMacchina
        inizia({ dispatch }, { id, macchinaId }) {
            return new Promise((resolve, reject) => {
                inizia_manutenzione(id).then(resp => {
                    dispatch("carica", { macchinaId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        // Wizard di chiusura: note, ricambi usati, flag automazione
        completa({ dispatch }, { id, dati, macchinaId }) {
            return new Promise((resolve, reject) => {
                completa_manutenzione(id, dati).then(resp => {
                    dispatch("carica", { macchinaId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        modificaRicambi({ dispatch }, { id, dati, macchinaId }) {
            return new Promise((resolve, reject) => {
                modifica_ricambi_manutenzione(id, dati).then(resp => {
                    dispatch("caricaDettaglio", id);
                    dispatch("carica", { macchinaId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, { id, ripristinaMagazzino, macchinaId }) {
            return new Promise((resolve, reject) => {
                elimina_manutenzione(id, ripristinaMagazzino).then(resp => {
                    dispatch("carica", { macchinaId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        duplica({ dispatch }, { id, macchinaId }) {
            return new Promise((resolve, reject) => {
                duplica_manutenzione(id).then(resp => {
                    dispatch("carica", { macchinaId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
        corrente: state => state.corrente,
    },
};

export default manutenzioni;